import ActionsBuilder from '../../../../utils/actions/ActionsBuilder';

export const IDENTIFIER = '[PARTNER COMPANIES]';

export default {
    ...ActionsBuilder.buildList(IDENTIFIER, false, true, true)
};
